import { AiImageModel } from 'dy-frontend-http-repository/lib/modules/AiImage/enums';

// GPT Image 2.5 Flare is not present in shared AiImageModel enum yet, so its key is declared locally
const aiImageModelInformation: {
    [model in AiImageModel | 'gpt_image_2_5_flare']: {
        name: string;
    };
} = {
    [AiImageModel.DALLE_2]: {
        name: 'dalle 2',
    },
    [AiImageModel.DALLE_3]: {
        name: 'dalle 3',
    },
    gpt_image_2_5_flare: {
        name: 'GPT Image 2.5 Flare',
    },
};

export default aiImageModelInformation;
